export default [
  {
    path: "/agenda",
    name: "agenda",
    component: () => import("../components/modules/agenda/AgendaList.vue"),
  },
];
